// businessNumber.js — a business's one Business Number and its type (issue
// #286). Mirrors backend/services/businessNumber.js; keep both in sync.
export const BUSINESS_NUMBER_TYPES = [
  { key: 'abn', label: 'ABN' },
  { key: 'nzbn', label: 'NZBN' },
  { key: 'ein', label: 'EIN' },
  { key: 'vat', label: 'VAT Number' },
  { key: 'company_number', label: 'Company Number' },
  { key: 'business_number', label: 'Business Number' },
];

const EU_COUNTRIES = [
  'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Czechia', 'Denmark', 'Estonia',
  'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania',
  'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden',
];
const COUNTRY_TYPES = {
  Australia: 'abn',
  'New Zealand': 'nzbn',
  'United States': 'ein',
  'United States of America': 'ein',
  USA: 'ein',
  'United Kingdom': 'company_number',
  ...Object.fromEntries(EU_COUNTRIES.map((c) => [c, 'vat'])),
};

export function businessNumberTypeForCountry(country) {
  return COUNTRY_TYPES[String(country || '').trim()] || 'business_number';
}

export function businessNumberLabel(type) {
  return (BUSINESS_NUMBER_TYPES.find((t) => t.key === type) || BUSINESS_NUMBER_TYPES[BUSINESS_NUMBER_TYPES.length - 1]).label;
}

// "ABN 51 824 753 556"-style spacing for an ABN; anything else as kept.
export function formatBusinessNumber(type, value) {
  if (!value) return '';
  if (type === 'abn' && /^[0-9]{11}$/.test(value)) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3 $4');
  return value;
}

// An ABN as it's typed, spaced "51 824 753 556": digits only, at most 11.
export function spaceAbnInput(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 11);
  return [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 8), digits.slice(8, 11)].filter(Boolean).join(' ');
}

// The ABR's check: take 1 from the first digit, weight each digit, and the
// total divides by 89.
const ABN_WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
export function isValidAbn(value) {
  const compact = String(value || '').replace(/\s/g, '');
  if (!/^[0-9]{11}$/.test(compact)) return false;
  const sum = compact.split('').reduce((total, d, i) => total + (Number(d) - (i === 0 ? 1 : 0)) * ABN_WEIGHTS[i], 0);
  return sum % 89 === 0;
}
